import { hasElements } from "./arrays";

export const hasPermission = (user, permission) => {
    if (!user || !hasElements(user.permissions)) {
        return false;
    }

    return user.isAdmin || user.permissions.includes(permission);
};

export const hasSettingsAccess = (user) => {
    if (!user || !hasElements(user.permissions)) return false;
    if (user.isAdmin) return true;
    return user.permissions.some((p) => /^settings\..+\.access$/.test(p));
};

export const hasSettingsPermission = (user, permissionKey) => {
    if (!permissionKey) return user.isAdmin;
    return hasPermission(user, permissionKey);
};
